import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import headshot from '../assets/cichon-headshot-160x215.318b9bee.webp';

const PrincipalInvestigator: React.FC = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      ref={ref}
      className="pt-12 md:pt-16 pb-20 md:pb-28 bg-neutral-light"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-penn-blue mb-6">
            Principal Investigator
          </h2>
          <div className="w-24 h-1 bg-penn-red mx-auto"></div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="bg-white rounded-lg shadow-lg overflow-hidden border border-neutral-medium"
        >
          <div className="md:flex">
            {/* Photo */}
            <div className="md:w-2/5 bg-gradient-to-br from-penn-blue to-penn-red p-8 flex items-center justify-center">
              <div className="relative w-70 h-90 md:w-80 md:h-96">
                <img
                  src={headshot}
                  alt="Joseph Cichon, MD, PhD"
                  className="w-full h-full object-cover rounded-lg shadow-xl border-4 border-white/30"
                />
              </div>
            </div>

            {/* Bio Content */}
            <div className="md:w-3/5 p-8 md:p-12">
              <h3 className="text-3xl md:text-4xl font-bold text-penn-blue mb-2">
                Joseph Cichon, MD, PhD
              </h3>
              <p className="text-xl text-penn-red mb-6 font-semibold">
                Assistant Professor of Anesthesiology & Critical Care
              </p>

              <div className="prose prose-lg max-w-none text-neutral-dark leading-relaxed">
                <p className="mb-4">
                  Joseph Cichon, MD, PhD, is a physician–neuroscientist and Assistant Professor
                  of Anesthesiology & Critical Care at the University of Pennsylvania. Trained
                  as an MD/PhD at NYU and subsequently a research fellow at Penn, Dr. Cichon has
                  helped define circuit mechanisms that underlie dissociative actions of ketamine.
                </p>
                <p className="mb-4">
                  Combining two-photon imaging with opto/chemogenetics and behavior, his lab maps
                  layer- and cell-type specific cortical dynamics to understand how anesthetics,
                  rapid-acting antidepressants, and psychedelics reshape circuits to alter
                  consciousness, mood, and pain.
                </p>
                <p className="font-semibold text-penn-blue">
                  The overall goal of our laboratory is to translate mechanistic circuit insights
                  into new strategies for treating depression, chronic pain, and disorders of arousal.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PrincipalInvestigator;


